/* HER CROWN theme scripts — cart drawer, mobile nav, search, variant picker.
   All commerce data comes from Shopify's AJAX Cart API. Nothing is hard-coded. */
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const money = (cents) =>
    (window.Shopify && window.Shopify.currency ? '' : '') +
    new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.HerCrown && window.HerCrown.currency) || 'USD'
    }).format(cents / 100);

  /* ---------- generic drawer toggles ---------- */
  function openDrawer(el) { if (el) { el.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer(el) { if (el) { el.classList.remove('is-open'); document.body.style.overflow = ''; } }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      const target = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      openDrawer(target);
      if (target && target.id === 'CartDrawer') refreshCart();
      return;
    }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { closeDrawer(closeBtn.closest('.overlay')); return; }
    if (e.target.classList && e.target.classList.contains('overlay')) closeDrawer(e.target);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.overlay.is-open').forEach(closeDrawer);
  });

  /* ---------- search ---------- */
  const searchToggle = $('[data-search-toggle]');
  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      const bar = $('#SearchBar');
      bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) $('input', bar).focus();
    });
  }

  /* ---------- cart ---------- */
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    const body = $('[data-cart-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-empty"><div><h3 class="display" style="font-size:1.5rem">Your bag awaits</h3>' +
        '<p class="muted-note" style="margin-top:.5rem">Discover a crown made for your next moment.</p>' +
        '<a class="btn" style="margin-top:1.5rem" href="/collections/all">Explore the collection</a></div></div>';
      return;
    }

    const lines = cart.items.map((item) => {
      const img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '">' : '<span></span>';
      const opts = (item.options_with_values || []).map((o) => o.value).join(' · ');
      return (
        '<article class="cart-line" data-line-key="' + item.key + '">' + img +
        '<div><h3 class="display">' + item.product_title + '</h3>' +
        '<p class="opts">' + opts + '</p>' +
        '<div class="qty"><button type="button" aria-label="Decrease quantity" data-qty="' + item.key + '" data-value="' + (item.quantity - 1) + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" aria-label="Increase quantity" data-qty="' + item.key + '" data-value="' + (item.quantity + 1) + '">+</button></div></div>' +
        '<div style="text-align:right"><p style="font-size:14px;font-weight:600;margin:0">' + money(item.final_line_price) + '</p>' +
        '<button type="button" class="btn btn--ghost" style="margin-top:2rem;font-size:11px;color:var(--muted-foreground)" data-qty="' + item.key + '" data-value="0">Remove</button></div></article>'
      );
    }).join('');

    body.innerHTML =
      '<div class="cart-lines">' + lines + '</div>' +
      '<div class="cart-foot"><div class="cart-total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<p class="muted-note" style="margin-bottom:1.25rem">Shipping and taxes are calculated at checkout.</p>' +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn--lg btn--full">Secure checkout</button></form></div>';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => {});
  }

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty]');
    if (!qtyBtn) return;
    const key = qtyBtn.getAttribute('data-qty');
    const quantity = parseInt(qtyBtn.getAttribute('data-value'), 10);
    qtyBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then((r) => r.json())
      .then(renderCart)
      .catch(refreshCart);
  });

  /* ---------- add to cart (product form + quick add) ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    if (button) button.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((res) => {
        if (res.status && res.status !== 200) throw new Error(res.description || 'Unable to add');
        openDrawer($('#CartDrawer'));
        return refreshCart();
      })
      .catch(() => { form.submit(); })
      .finally(() => { if (button) button.disabled = false; });
  });

  /* ---------- product variant picker ---------- */
  $$('[data-variant-picker]').forEach((picker) => {
    const data = JSON.parse($('[data-variant-json]', picker).textContent);
    const selects = $$('select[data-option-index]', picker);
    const idInput = $('input[name="id"]', picker.closest('form') || picker);
    const priceEl = $('[data-variant-price]', picker);
    const addBtn = $('[data-add-button]', picker.closest('form') || picker);
    const mainImg = $('[data-main-image]');

    function update() {
      const chosen = selects.map((s) => s.value);
      const variant = data.find((v) => v.options.every((opt, i) => opt === chosen[i]));
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (mainImg && variant.image) mainImg.src = variant.image;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    selects.forEach((s) => s.addEventListener('change', update));
    update();
  });

  /* ---------- product gallery thumbnails ---------- */
  $$('[data-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const main = $('[data-main-image]');
      if (main) main.src = btn.getAttribute('data-thumb');
      $$('[data-thumb]').forEach((b) => b.setAttribute('aria-current', String(b === btn)));
    });
  });

  refreshCart();
})();
